import React from "react";
import { Container } from "react-bootstrap";
import { ImageElement } from "../UiElement";
import { Link } from "react-router-dom";

function UserLandingFooter() {
  //year
  const currentYear = new Date().getFullYear();
  return (
    <>
      <footer className="mainFooter bg-light">
        <Container>
          <div className="mainFooter_logo text-center">
            <ImageElement source="logo.svg" className="img-fluid" alt="logo" isLightbox={false} />
            <p>We provide the best tour facilities</p>
            <Link to="/user-landing/privacy">Privacy Policy |</Link>
            <Link to="/user-landing/terms">Terms & Conditions |</Link>
            <Link to="/user-landing/faq">Faq's </Link>
          </div>
          <div className="mainFooter_social">
            <Link to="/" target="_blank" aria-label="Facebook"><em className="tripon-facebook" /></Link>
            <Link to="/" target="_blank" aria-label="Instagram"><em className="tripon-instagram" /></Link>
            <Link to="/" target="_blank" aria-label="inkedin"><em className="tripon-linkedin" /></Link>
          </div>
          <div className="mainFooter_copy">Copyright ©{currentYear} Tournut All Rights Reserved. | Powered by <Link to="https://priordesignstudio.in/" target="_blank">PriorDesignStudio</Link></div>
        </Container>
      </footer>
    </>
  );
}

export default UserLandingFooter;
